import React, { useEffect, useState, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import "./Cart.css";
import img1 from "../../assets/images/Tradevibe/signinLogo.png";
import { axiosInstance } from "../../axiosInstance";
import Pagination from "@mui/material/Pagination";
import { useFormik } from "formik";
import { Modal } from "react-bootstrap";
import * as yup from "yup";
import { useCart } from "../../Components/CartContext";
import { MdDelete } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaCartPlus } from "react-icons/fa6";
import { MdMyLocation } from "react-icons/md";

let placeOrderSchema = yup.object({
  products: yup.array().of(
    yup.object({
      qty: yup
        .number()
        .required("Qty is required")
        .positive("Qty must be greater than 0"),
    }),
  ),
  delivery_city: yup
    .string()
    .matches(/^[A-Za-z\s]+$/, "City must contain only letters"),

  delivery_district: yup
    .string()
    .matches(/^[A-Za-z\s]+$/, "District must contain only letters"),

  delivery_state: yup
    .string()
    .matches(/^[A-Za-z\s]+$/, "State must contain only letters"),

  delivery_pincode: yup
    .string()
    .matches(/^[0-9\s]+$/, "Pincode must contain only numbers"),
  // payment_type: yup.string().required("Payment type is required"),
  // payment_mode: yup.string().required("Payment mode is required"),
});

export const Cart = () => {
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cartData, setCartData] = useState([]);
  const navigate = useNavigate();

  const { setCartCount } = useCart();

  // get location
  const [error, setError] = useState("");

  const getLocation = () => {
    setIsLoading(true);
    setError("");

    if (!navigator.geolocation) {
      setError("Geolocation is not supported");
      setIsLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          const lat = pos.coords.latitude;
          const lng = pos.coords.longitude;

          const res = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`,
          );

          const data = await res.json();

          if (data.status !== "OK") {
            throw new Error("Geocoding failed");
          }

          const result = data.results[0];
          const components = result.address_components;

          const getComponent = (type) => {
            const comp = components.find((c) => c.types.includes(type));
            return comp ? comp.long_name : "";
          };

          const delivery_address = result.formatted_address;

          const delivery_city =
            getComponent("locality") ||
            getComponent("sublocality") ||
            getComponent("administrative_area_level_3");

          const delivery_district =
            getComponent("administrative_area_level_2") ||
            getComponent("administrative_area_level_3");

          const delivery_state = getComponent("administrative_area_level_1");

          const delivery_pincode = getComponent("postal_code");

          placeOrderFormik.setValues({
            ...placeOrderFormik.values,
            delivery_address,
            delivery_city,
            delivery_district,
            delivery_state,
            delivery_pincode,
          });
        } catch (e) {
          console.error(e);
          setError("Failed to get address");
        }

        setIsLoading(false);
      },

      (err) => {
        console.error(err);

        if (err.code === 1) {
          setError("Location permission denied");
        } else if (err.code === 3) {
          setError("Location timeout");
        } else {
          setError("Unable to fetch location");
        }

        setIsLoading(false);
      },

      {
        enableHighAccuracy: true, // better for Google
        timeout: 20000,
        maximumAge: 60000,
      },
    );
  };

  async function fetchCartDetails() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/agent/cart/");
      if (response.data.status === "Succcess" || response.status === 200) {
        setCartData(response.data);
        console.log(
          response.data.message || "Cart details fetched successfully!",
        );
        //  update count in header
        const count = response.data?.cart_detail?.items_count || 0;
        setCartCount(count);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch cart details",
      );
      console.log("Failed to fetch cart details");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchCartDetails();
  }, []);

  const handleIncrement = (product_id, currentQty) => {
    handleUpdateCart(product_id, currentQty + 1);
  };
  const handleDecrement = (product_id, currentQty) => {
    handleUpdateCart(product_id, currentQty - 1);
  };
  const handleDelete = (product_id, newQty = 0) => {
    handleUpdateCart(product_id, newQty);
  };
  const debounceRef = useRef(null);
  const [tempQty, setTempQty] = useState({});
  const handleInputQtyChange = (product_id, value) => {
    // clear previous timer
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    // allow empty input so user can delete existing qty
    if (value === "") return;

    debounceRef.current = setTimeout(() => {
      const qty = Number(value);
      if (isNaN(qty) || qty < 0) return;

      handleUpdateCart(product_id, qty);
    }, 500);
  };

  async function handleUpdateCart(productId, newQty) {
    try {
      setLoading(true);
      const payload = {
        products: [
          {
            product_id: productId,
            qty: newQty,
          },
        ],
      };
      const response = await axiosInstance.post("/agent/cart/", payload);
      if (response.data.status === "Success" || response.status === 200) {
        // toast.success(response.data.message || "Product added to cart");
        console.log("Product added to cart");
        fetchCartDetails();
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to add in cart");
      console.log("Failed to add in cart");
    } finally {
      setLoading(false);
    }
  }

  // place order modal state
  const [placeOrdershow, setPlaceOrderShow] = useState(false);

  const handlePlaceOrderClose = () => setPlaceOrderShow(false);
  //send get cart api products to place order
  const handlePlaceOrderShow = () => {
    setPlaceOrderShow(true);
    const productsData =
      cartData?.cart_items?.map((item) => ({
        product_id: item.product_id,
        qty: item.qty,
      })) || [];
    placeOrderFormik.setFieldValue("products", productsData);
  };

  // const [productId, setProductId] = useState("");
  // console.log("productId", productId);

  const placeOrderFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      delivery_address: "",
      delivery_city: "",
      delivery_district: "",
      delivery_state: "",
      delivery_pincode: "",
      delivery_state_code: 0,
      payment_type: "debit", // as now sending statically
      payment_mode: "cash", // as now sending statically
      // products: [
      //   {
      //     product_id: productId,
      //     qty: "",
      //   },
      // ],
      products: [],
    },
    validationSchema: placeOrderSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const response = await axiosInstance.post(
          "/agent/place-order/",
          values,
        );
        if (response.data.status === "Success" || response.status === 200) {
          resetForm();
          handlePlaceOrderClose();
          fetchCartDetails();
          toast.success(response.data.message || "Order placed successfully");
          console.log(response.data.message || "Order placed successfully");
        }
      } catch (error) {
        toast.error(error.response.data.message || "Failed to place order");
        console.log("Failed to place order");
      } finally {
        setLoading(false);
      }
    },
  });
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "#45614c" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />

      <div className="cartContainer">
        <div className="container">
          <div>
            {cartData?.cart_items?.length > 0 ? (
              <>
                <h2 className="cartTitle">Shopping Cart</h2>
                <div className="cartGrid">
                  {/* LEFT - PRODUCTS */}
                  <div className="cartLeft">
                    {cartData?.cart_items?.length > 0 ? (
                      cartData?.cart_items?.map((cart) => {
                        const actualPrice = Number(cart.price) || 0;
                        const percentage = Number(cart.product_percentage) || 0;

                        const discountPrice = Number(
                          ((actualPrice * percentage) / 100).toFixed(2),
                        );

                        const afterDiscountPrice = Number(
                          (actualPrice - discountPrice).toFixed(2),
                        );
                        return (
                          <div className="cartItem">
                            <img
                              src={cart.product_image}
                              alt="product"
                              className="cartImg"
                            />

                            <div className="cartDetails">
                              <div className="productName">
                                {cart.product_name}
                              </div>

                              <div className="priceRow">
                                <strike>₹{cart.price}</strike>
                                <span className="price">
                                  ₹{afterDiscountPrice}
                                </span>
                                {cart.product_percentage && (
                                  <span className="discount">
                                    {cart.product_percentage}% OFF
                                  </span>
                                )}
                              </div>

                              {/* Quantity */}
                              <div className="qtyContainer">
                                <button
                                  onClick={() =>
                                    handleDecrement(cart.product_id, cart.qty)
                                  }
                                >
                                  -
                                </button>

                                <input
                                  type="number"
                                  className="qtyInput"
                                  value={tempQty[cart.product_id] ?? cart.qty}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    setTempQty((prev) => ({
                                      ...prev,
                                      [cart.product_id]: value,
                                    }));

                                    handleInputQtyChange(
                                      cart.product_id,
                                      value,
                                    );
                                  }}
                                />
                                <button
                                  onClick={() =>
                                    handleIncrement(cart.product_id, cart.qty)
                                  }
                                >
                                  +
                                </button>
                              </div>
                            </div>
                            <div>
                              <MdDelete
                                className="fs-6"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDelete(cart.product_id)}
                              />
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div>Cart is empty</div>
                    )}
                  </div>

                  {/* RIGHT - SUMMARY */}
                  <div className="cartRight">
                    <div className="cartRightTitle">Price Details</div>

                    <div className="priceDetails">
                      <div>
                        <span>Total Amount</span>
                        <span>₹{cartData?.total_amount ?? 0}</span>
                      </div>
                      <div>
                        <span>Total Discount</span>
                        <span className="green">
                          -₹{cartData?.total_discount ?? 0}
                        </span>
                      </div>
                      <div className="total">
                        <span>Payable</span>
                        <span>₹{cartData?.grand_total ?? 0}</span>
                      </div>
                    </div>

                    <button
                      className="placeOrderBtn"
                      onClick={() => {
                        // setProductId(product.id);
                        handlePlaceOrderShow();
                      }}
                    >
                      Proceed to Buy
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="emptyCart">
                <div className="emptyCartIcon">
                  <FaCartPlus />
                </div>

                <h4>Your cart feels lonely </h4>
                <p>Add some products to get started</p>

                <button
                  className="shopNowBtn"
                  onClick={() => navigate("/home")}
                >
                  Shop Now
                </button>
              </div>
            )}
          </div>
          {/* place order modal  */}

          <Modal
            className="placeOrderModal"
            show={placeOrdershow}
            onHide={handlePlaceOrderClose}
            centered
            size="lg"
          >
            <form onSubmit={placeOrderFormik.handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>Order Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="placeModalGrid">
                  {/* <div>
                    <label>
                      Quantity <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder="Enter Quantity"
                      name="products[0].qty"
                      value={placeOrderFormik.values.products[0].qty}
                      onChange={placeOrderFormik.handleChange}
                    />
                    {placeOrderFormik.errors.products?.[0]?.qty &&
                      placeOrderFormik.touched.products?.[0]?.qty && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {placeOrderFormik.errors.products[0].qty}
                        </div>
                      )}
                  </div> */}
                  <div>
                    <label>Address</label>
                    <input
                      type="text"
                      placeholder="Enter Address"
                      name="delivery_address"
                      value={placeOrderFormik.values.delivery_address}
                      onChange={placeOrderFormik.handleChange}
                    />
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#0d6efd",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                      onClick={getLocation}
                    >
                      {isLoading ? (
                        "Fetching..."
                      ) : (
                        <span>
                          <MdMyLocation style={{ marginRight: "1px" }} /> Use
                          current location
                        </span>
                      )}
                      {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                  </div>
                  <div>
                    <label>City</label>
                    <input
                      type="text"
                      placeholder="Enter City"
                      name="delivery_city"
                      value={placeOrderFormik.values.delivery_city}
                      onChange={placeOrderFormik.handleChange}
                    />
                    {placeOrderFormik.errors.delivery_city &&
                      placeOrderFormik.touched.delivery_city && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {placeOrderFormik.errors.delivery_city}
                        </div>
                      )}
                  </div>

                  <div>
                    <label>District</label>
                    <input
                      type="text"
                      placeholder="Enter District"
                      name="delivery_district"
                      value={placeOrderFormik.values.delivery_district}
                      onChange={placeOrderFormik.handleChange}
                    />
                    {placeOrderFormik.errors.delivery_district &&
                      placeOrderFormik.touched.delivery_district && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {placeOrderFormik.errors.delivery_district}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>State</label>
                    <input
                      type="text"
                      placeholder="Enter State"
                      name="delivery_state"
                      value={placeOrderFormik.values.delivery_state}
                      onChange={placeOrderFormik.handleChange}
                    />
                    {placeOrderFormik.errors.delivery_state &&
                      placeOrderFormik.touched.delivery_state && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {placeOrderFormik.errors.delivery_state}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>Pin Code</label>
                    <input
                      type="text"
                      placeholder="Enter Pin Code"
                      name="delivery_pincode"
                      value={placeOrderFormik.values.delivery_pincode}
                      onChange={placeOrderFormik.handleChange}
                    />
                    {placeOrderFormik.errors.delivery_pincode &&
                      placeOrderFormik.touched.delivery_pincode && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {placeOrderFormik.errors.delivery_pincode}
                        </div>
                      )}
                  </div>
                  {/* <div>
                    <label>State Code</label>
                    <input
                      type="number"
                      min={0}
                      placeholder="Enter State Code"
                      name="delivery_state_code"
                      value={placeOrderFormik.values.delivery_state_code}
                      onChange={placeOrderFormik.handleChange}
                    />
                  </div> */}

                  {/* <div>
                    <label>
                      Payment Type <span className="text-danger">*</span>
                    </label>
                    <select
                      name="payment_type"
                      onChange={placeOrderFormik.handleChange}
                      value={placeOrderFormik.values.payment_type}
                    >
                      <option value={""} disabled selected>
                        Select
                      </option>
                      <option value="debit">Debit</option>
                      <option value="credit">Credit</option>
                    </select>
                    {placeOrderFormik.errors.payment_type &&
                      placeOrderFormik.touched.payment_type && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {placeOrderFormik.errors.payment_type}
                        </div>
                      )}
                  </div> */}
                  {/* <div>
                    <label>
                      Payment Method <span className="text-danger">*</span>
                    </label>
                    <select
                      name="payment_mode"
                      onChange={placeOrderFormik.handleChange}
                      value={placeOrderFormik.values.payment_mode}
                    >
                      <option value={""} disabled selected>
                        Select
                      </option>
                      <option value="upi">UPI</option>
                      <option value="cash">Cash</option>
                    </select>
                    {placeOrderFormik.errors.payment_mode &&
                      placeOrderFormik.touched.payment_mode && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {placeOrderFormik.errors.payment_mode}
                        </div>
                      )}
                  </div> */}
                </div>
              </Modal.Body>
              <Modal.Footer className="btnPlaceModal">
                <button
                  type="button"
                  className="btnPlaceModalCancel"
                  onClick={handlePlaceOrderClose}
                >
                  Cancel
                </button>
                <button type="submit" className="btnPlaceModalPlace">
                  Place Order
                </button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>
      </div>
    </>
  );
};
